import { render, staticRenderFns } from "./DomainRoot.vue?vue&type=template&id=1a6fb7df&scoped=true&"
import script from "./DomainRoot.vue?vue&type=script&lang=js&"
export * from "./DomainRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6fb7df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a6fb7df')) {
      api.createRecord('1a6fb7df', component.options)
    } else {
      api.reload('1a6fb7df', component.options)
    }
    module.hot.accept("./DomainRoot.vue?vue&type=template&id=1a6fb7df&scoped=true&", function () {
      api.rerender('1a6fb7df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/files/DomainRoot.vue"
export default component.exports